export const getBasicAuthHeader = (
    username: string,
    password: string,
): string => {
    const credentials = `${username.trim()}:${password.trim()}`;
    const base64Credentials = btoa(credentials);
    return `Basic ${base64Credentials}`;
};
